import { IMaskInput } from 'react-imask';
import { forwardRef } from 'react';
import { parse } from 'date-fns';

interface MaskProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  textmask: string;
}

export const TextMask = forwardRef<HTMLElement, MaskProps>(({ onChange, name, ...props }: MaskProps, ref) => {
  let mask: any = '(000) 000-0000',
    pattern: string | undefined;
  if (props.textmask === 'Date') {
    mask = Date;
    pattern = '00/00/00000';
  }

  return (
    <IMaskInput
      {...props}
      inputRef={ref as any}
      mask={mask}
      onAccept={(value: any) => onChange({ target: { name: name, value } })}
      parse={(date) => parse(date, 'MM/dd/yyyy', new Date())}
      pattern={pattern}
    />
  );
});
TextMask.displayName = 'TextMask';
